module.exports = __webpack_public_path__ + "public/img/bzry.34522800.png";